// import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import GreetingSection from '../../components/navbar/GreetingSection';
import { useLocation } from 'react-router-dom';

import { PoliciesValues } from './components';
const PoliciesDetailPageContainer = styled.div`
  margin: 0;
  dispay: flex;
`;
interface PvLocationState {
  policyNo?: string;
  companyCode?: string;
}
const PoliciesValuesPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const pValues = (location.state as PvLocationState) ?? {};
  console.log(pValues);
  return (
    <PoliciesDetailPageContainer>
      <GreetingSection pageName={t('life.policies.policyValueTitle')} showicon={false} />
      <PoliciesValues pValues={pValues}></PoliciesValues>
    </PoliciesDetailPageContainer>
  );
};

export default PoliciesValuesPage;
